export default "__VITE_ASSET__CP9_fzkS__"